// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4db3ec34","455":"6ae2724d"}[chunkId] + ".chunk.js";
};